import { UnsavedImDfm3dSlideStateType } from '~/redux-modules/unsaved-im-dfm-3d-slides/reducer'

import { imDfmFeedback_quoteModelRevision_dfmFeedback as ImDfmFeedbackType } from './__generated__/imDfmFeedback'
import { Is2dDfmSlideReady_is2dDfmSlideReady as DfmFeedbackStatusType } from './__generated__/Is2dDfmSlideReady'

export const getActiveSlideIndex = (activeSlideIndex: number) => {
    if (activeSlideIndex === 1) {
        return 1
    }

    return activeSlideIndex - 2
}

export const getDfmIdList = (
    unsavedImDfm3dSlidesList: UnsavedImDfm3dSlideStateType,
    savedImDfm: ImDfmFeedbackType[],
) => {
    const allDfmIds: string[] = []

    unsavedImDfm3dSlidesList.forEach((dfm: UnsavedImDfm3dSlideStateType) =>
        allDfmIds.push(dfm.slideId),
    )
    savedImDfm.forEach(dfm => allDfmIds.push(dfm.id))

    return allDfmIds
}

export const getRecentDfmIds = (
    savedImDfm: ImDfmFeedbackType[] | undefined,
) => {
    const dfmIds: string[] = []

    if (savedImDfm) {
        return savedImDfm
            .filter(
                (dfm: ImDfmFeedbackType) => !dfm.attachment && !dfm.isPublished,
            )
            .map(dfm => dfm.id)
    }

    return dfmIds
}

export const shouldStartPolling = (
    dfmFeedbackStatus: DfmFeedbackStatusType[],
) => {
    let startPolling = false

    if (dfmFeedbackStatus?.length === 1) {
        if (dfmFeedbackStatus[0]?.loading || dfmFeedbackStatus[0]?.error) {
            startPolling = true
        }
    } else {
        dfmFeedbackStatus.forEach((dfm: DfmFeedbackStatusType) => {
            if (dfm.loading) {
                startPolling = true
            }
        })
    }

    return startPolling
}

export const getSlide2dDfmStatus = (
    dfmId: string | undefined,
    dfmFeedbackStatus: DfmFeedbackStatusType[] = [],
) => {
    return dfmFeedbackStatus.find(
        (dfm: DfmFeedbackStatusType) => dfm.feedbackId === dfmId,
    )
}

export const getSlideSourceType = (
    dfmFeedback: ImDfmFeedbackType[],
    selectedSlideDfmId: string,
) => {
    const selectedDfmFeedback = dfmFeedback?.find(dfm => {
        return dfm?.id === selectedSlideDfmId
    })

    return selectedDfmFeedback?.sourceType
}

export const reorderDndList = <T>(
    list: T[],
    startIndex: number,
    endIndex: number,
) => {
    const result = [...list]
    const [removed] = result.splice(startIndex, 1)

    result.splice(endIndex, 0, removed)

    return result
}
